import React from 'react';
import { Button } from './ui/Button';
// Hand-drawn brush stroke highlight - sits behind text like a marker highlight
function BrushStrokeHighlight({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 300 24" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-86" data-mp="9ka2cotbuas6">
      {/* Main brush stroke with organic, hand-drawn feel */}
      <path d="M8 14C12 11 28 9 45 10C62 11 78 8 95 9C112 10 128 7 145 8C162 9 178 6 195 8C212 10 228 7 245 9C262 11 278 8 292 10" stroke="currentColor" strokeWidth="12" strokeLinecap="round" strokeLinejoin="round" opacity="0.85" data-id="element-87" data-mp="12861s1aa6gsn" />
      {/* Secondary stroke for texture */}
      <path d="M15 16C35 12 55 14 75 13C95 12 115 15 135 14C155 13 175 16 195 14C215 12 235 15 255 13C275 11 285 14 290 13" stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" opacity="0.6" data-id="element-88" data-mp="neauv0tor1k3" />
      {/* Accent stroke for more organic feel */}
      <path d="M5 12C25 15 45 11 65 13C85 15 105 10 125 12C145 14 165 9 185 11C205 13 225 10 245 12C265 14 280 11 295 13" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" opacity="0.4" data-id="element-89" data-mp="3o7c243hhyzj9" />
    </svg>;
}
export function Hero() {
  return <section className="relative w-full py-24 md:py-32 lg:py-40 px-4 overflow-hidden" data-id="element-90" data-mp="30gzwiz9q5evu">
      <div className="max-w-4xl mx-auto text-center" data-id="element-91" data-mp="3599ent4llank">
        <p className="inline-block text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-[#c06a2b] bg-[#ecdfd2]/60 rounded-full px-4 py-2 mb-8" data-id="element-92" data-mp="35aue9x5rrjsa">
          Thank you, Harrisonburg &amp; Rockingham
        </p>

        <div className="space-y-2 md:space-y-4 mb-8 md:mb-12" data-id="element-93" data-mp="2hj5clq725iyo">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#3b2316] tracking-tight leading-tight" data-id="element-94" data-mp="2hjyp77sp72oq">
            <span className="block" data-id="element-95" data-mp="2lmuyg7wclmg0">We Celebrated.</span>
            <span className="block text-[#c06a2b]" data-id="element-96" data-mp="s333va8e4ivy">We Honored.</span>
            <span className="relative inline-block" data-id="element-97" data-mp="nbl2il2gggag">
              {/* Brush stroke highlight behind the text */}
              <BrushStrokeHighlight className="absolute left-[-5%] right-[-5%] bottom-[5%] md:bottom-[8%] w-[110%] h-[35%] md:h-[30%] text-[#d4956a] -z-10" data-id="element-98" data-mp="ibgmew5glnkr" />
              <span className="relative" data-id="element-99" data-mp="dbapp1kc1avt">We Showed Up.</span>
            </span>
          </h1>
        </div>

        <p className="text-xl md:text-2xl text-[#5a3a28]/80 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-100" data-mp="1ayjep6jjl22k">
          This June, children from 3rd grade through 12th grade honored the
          fathers and father-figures in their lives &mdash; in their own words,
          in front of their whole community.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-101" data-mp="3lsp3hdsd4jef">
          <Button href="#gallery" className="text-lg px-8 py-4" data-id="element-102" data-mp="3lqm1dvdxqztc">
            See the Celebration
          </Button>
          <Button href="#event" variant="outline" className="text-lg px-8 py-4" data-id="element-103" data-mp="1x9b6f48dr7e5">
            We'll Be Back in 2027
          </Button>
        </div>
      </div>
    </section>;
}